import { FC } from 'react';

import { GlobalStateConsumer } from 'common/apps/core/StateConsumer';
import { useGlobalApi } from 'common/apps/core/ApiConsumer';
import { ModalsContainer } from 'common/components/ModalsContainer';

import { modalsStateSelector } from './selectors';
import { ModalsModuleApi } from './types';

type ModalsProps = {
  containerId: string;
};

const Modals: FC<ModalsProps> = ({ containerId }) => {
  const api = useGlobalApi<{ modals: ModalsModuleApi }>();

  return (
    <GlobalStateConsumer selector={modalsStateSelector}>
      {({ modalName, params, containerId: currentContainerId }) =>
        containerId === currentContainerId && modalName ? (
          <ModalsContainer
            currentModalName={modalName}
            currentModalParams={params!}
            onClose={api.modals.handleClose}
          />
        ) : null
      }
    </GlobalStateConsumer>
  );
};

export default Modals;
